export function findLinkedCorrelationsBySignalID(correlations, signalID) {
    return correlations.filter((_correlation) => _correlation.link.some((_link) => _link.signal.id === signalID));
}
//# sourceMappingURL=findLinkedCorrelationsBySignalID.js.map